module.exports = function ($httpProvider, $provide) {
    $provide.factory('http401Interceptor', [
        '$q', '$injector', '$window', 'LoadingIndicatorService',
        function ($q, $injector, $window, loadingIndicator) {
            return {
                responseError(rejection) {
                    const $rootScope = $injector.get('$rootScope');

                    if (rejection.status === 401) {
                        const loginService = $injector.get('LoginService');

                        loginService.invalidateLogin();
                        $rootScope.$broadcast('session:timeout');
                        loadingIndicator.finishLoading();
                        loginService.promptForLogin(loginService.LoginToContinueMessage);
                    }
                    const $state = $injector.get('$state');
                    if (rejection.status === 404) {
                        $rootScope.$broadcast('error');
                        $state.go('error.404', null, { location: 'replace' });
                    }
                    if (rejection.status === 500) {
                        $rootScope.$broadcast('error');
                        $state.go('error.500');
                    }
                    if (rejection.status === 403) {
                        $rootScope.$broadcast('error');
                        $state.go('error.403');
                    }
                    if (rejection.status === -1) {
                        // network error - shouldn't push them to any state.
                        $rootScope.$broadcast('offline');
                    }

                    return $q.reject(rejection);
                },
            };
        },
    ]);

    $provide.factory('http200Interceptor', [
        '$rootScope', function ($rootScope) {
            return {
                response(response) {
                    if (response.status === 200) {
                        // Reset the reservation timer
                        $rootScope.$broadcast('http:success');
                    }

                    return response;
                },
            };
        },
    ]);

    $httpProvider.interceptors.push('http401Interceptor');
    $httpProvider.interceptors.push('http200Interceptor');
};



// WEBPACK FOOTER //
// ./src/configuration/http.js